import { FormGroup, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { luhnCheck } from 'src/@omnial/_models/credit-cards/luhn.helper';

export function EmailRegEx(control: FormControl): { [key: string]: any } {
  const emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
}

export function MatchValidator(control: AbstractControl) {
  const password: string = control.get("password").value;
  const confirmPassword: string = control.get("confirmPassword").value;
  if (password !== confirmPassword) {
    control.get("confirmPassword").setErrors({ mismatch: true });
  } else {
    return null;
  }
}

export function CardNumberValidator(control: FormControl): { [key: string]: any } {
  if (control.value && !luhnCheck(control.value)) {
    return { CardNumberValidator: true };
  }
}

export function CardExpiryValidator(control: FormControl): { [key: string]: any } {
  if (control.value < 6) {
    return { CardExpiryValidator: true };
  }
  const month = parseInt(control.value.substr(0, 2), 10);
  const year = parseInt(control.value.substr(3, 4), 10);
  const today = new Date();
  if (year < today.getFullYear()) {
    return { CardExpiryValidator: true };
  }
  if (year === today.getFullYear() && month <= today.getMonth()) {
    return { CardExpiryValidator: true };
  }
  return null;
}

export function CardCvvValidator(control: FormControl): { [key: string]: any } {
  if (control.value.length > 4 || control.value.length < 3) {
    return { CardCvvValidator: true };
  }
  if (isNaN(control.value)) {
    return { CardCvvValidator: true };
  }
  return null;
}
